module.exports = __webpack_public_path__ + "img/turnitin.e0c08310.png";